import { render } from "./normscaleselector.vue?vue&type=template&id=42c8eb10&scoped=true"
import script from "./normscaleselector.vue?vue&type=script&lang=js"
export * from "./normscaleselector.vue?vue&type=script&lang=js"

import "./normscaleselector.vue?vue&type=style&index=0&id=42c8eb10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c8eb10"]])

export default __exports__